<div class="p-0">
    <mat-divider></mat-divider>
    <div class="row mt-4 mb-4">
        <div class="col-md-12" *ngIf="upgradeDetails.userType!=='Platform'">
            <p class="mb-0"><b>Your subscription plan allows you to create only {{upgradeDetails.count}} users.</b></p>
            <p class="pt-3 pb-3 mt-0 mb-0"><b>Please contact our sales team for upgrading your account.</b></p>
            <p class="mb-0 pb-3"><b>Sales</b></p>
            <p class="mb-0">Phone - 617-865-8444</p>
            <p class="mb-0">Email - Sales@imagility.co</p>
        </div>
        <!-- display a different message only for plateform admin -->
        <div class="col-md-12" *ngIf="upgradeDetails.userType=='Platform'">
            <p class="font-weight-bold">This company exceeded the user limit. Please update the number of users to add more users.</p>
        </div>
    </div> 
    <mat-divider></mat-divider>
    <div class="d-flex justify-content-end align-items-center mt-3">
    <button class="btn mr-4 cancelBtn" type="button" (click)="closeDialog()">Cancel</button>
    <span *ngIf="upgradeDetails.userType!=='Platform'">
        <button class="btn btn-primary" type="button" (click)="notifySalesTeam()">Notify Sales Team</button>
    </span>
    </div>
</div>